<template>
  <div>
    <DataTableWrapper
      ref="tableWrapper"
      :initialSortBy="[{ field: 'createdAt', dir: 'desc' }]"
      :data-source="{
        type: 'AxisGQL',
        query: require('@/services/gql/types/Accounts/queries/accountsGrid.gql')
      }"
      :headers="$options.headersConfig"
      :filters="{
        title: { control: 'text', modifier: 'contains' },
        email: { control: 'text', modifier: 'contains' },
        phone: { control: 'text', modifier: 'contains' },
        createdAt: { control: 'date-range' },
        updatedAt: { control: 'date-range' }
      }"
      @query-state-updated="getStateQuery"
      :stored-headers="getCurrentViewCols"
      :views-list="getViewList"
      :active-view-key="getActiveViewKey"
      :views-loading="$async.updateMe.$pending"
      @view-changed="updateStoredView"
      @active-view-changed="updateStoredActiveView"
      @remove-view="removeStoredView"
      @data-loaded="onTableDataChange"
    >
      <template v-slot="{ tableProps, tableListeners, filtersProps, filtersListeners }">
        <v-data-table
          v-model="mixSelectedItems"
          fixed-header
          height="80vh"
          :items-per-page="$options.perPage.itemsPerPage"
          :footer-props="{ itemsPerPageOptions: $options.perPage.itemsPerPageOptions }"
          v-bind="tableProps"
          v-on="tableListeners"
        >
          <template v-for="(h, i) in $options.headersConfig" v-slot:[`header.${h.value}`]>
            <v-tooltip open-delay="350" :key="i" bottom>
              <template v-slot:activator="{ on }">
                <!-- <span v-on="on">{{
                  $t(`events-categories.header-titles.${h.value}`)
                }}</span> -->
                <span v-on="on">
                  {{ h.text }}
                </span>
              </template>
              <span>{{ h.description }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`body.prepend`]="{}">
            <DataTableFilters
              is-grid-selectable
              v-bind="filtersProps"
              v-on="filtersListeners"
            />
          </template>
          <template
            v-for="(h, i) in $options.headersConfig"
            v-slot:[`item.${h.value}`]="{ item }"
          >
            <div :key="i">
              <div v-if="h.type === 'number' && item[h.value] !== null">
                {{formatAmount(item[h.value], '0') }}
              </div>
              <div v-else-if="h.value === 'email'">
                <router-link
                  title="Редактировать"
                  :to="{
                    name: 'page-account',
                    params: { id: item.id }
                  }"
                >{{ item[h.value] }}</router-link
                >
              </div>
              <div v-else-if="h.value === 'phone'">
                <router-link
                  title="Редактировать"
                  :to="{
                    name: 'page-account',
                    params: { id: item.id }
                  }"
                >{{ convertToPhone(item[h.value]) }}</router-link
                >
              </div>
              <div v-else-if="h.type === 'date'">
                <DateTimeCell :value="item[h.value]" />
              </div>
              <div v-else-if="h.type === 'boolean'">
                <v-icon
                  v-text="'mdi-checkbox-marked-circle'"
                  :color="item[h.value] ? 'success' : 'grey'"
                />
              </div>
              <div v-else-if="h.type === 'array'">
                {{ item[h.value].join(' ') }}
              </div>
              <div v-else-if="h.type === 'actions'">
                <router-link
                  :to="{
                    name: 'page-account',
                    params: { id: item.id }
                  }"
                  title="Редактировать"
                  ><v-btn icon><v-icon>mdi-pencil</v-icon></v-btn></router-link
                >
                <a title="Удалить">
                  <v-btn icon @click="deleteAccount(item.id)">
                    <v-icon color="red">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </a>
              </div>
              <div v-else>
                {{ item[h.value] }}
              </div>
            </div>
          </template>
        </v-data-table>
      </template>
    </DataTableWrapper>
    <ConfirmationDialog ref="confirmUserEmoving" confirmText="Удалить" />
  </div>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import { formatAmount } from '@/utils'
import perPage from '@/configs/v-data-table.js'
import headersConfig from './headersConfig.js'
import DataTableWrapper from '@/components/data-table-wrapper'
import DataTableFilters from '@/components/data-table-filters'
import DateTimeCell from '@/components/date-time-cell'
import { paramsToListQueryInput } from '@/components/data-table-wrapper/data-sources/axis-gql/utils'
import deleteAccount from '@/services/gql/types/Accounts/mutations/deleteAccount.gql'
import updateMeMutation from '@/services/gql/types/Me/mutations/updateMe.gql'
import { gridDependentMixin } from '@/pages/grid-dependent.mix'
import { convertToPhone } from '@/configs/numbers'

export default {
  name: 'GridAccounts',
  gridType: 'accounts',
  components: {
    DataTableWrapper,
    DataTableFilters,
    DateTimeCell,
    ConfirmationDialog
  },
  perPage,
  headersConfig,
  props: {
    items: {
      type: Array,
      default: null
    }
  },
  mixins: [gridDependentMixin],
  data () {
    return {
      queryState: null
    }
  },
  methods: {
    formatAmount,
    convertToPhone,
    getStateQuery (state) {
      this.queryState = paramsToListQueryInput(state)
    },
    refetch () {
      this.$refs.tableWrapper.refresh()
    },
    async deleteAccount (accountId) {
      try {
        await this.$refs.confirmUserEmoving.open()
        await this.$async.deleteAccount.$perform({
          id: Number(accountId)
        })
        this.$successMsg('Пользователь удален')
        this.refetch()
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e.graphQLErrors, 'account.delete')
      }
    }
  },
  async: {
    deleteAccount (variables) {
      return this.$apollo.mutate({
        mutation: deleteAccount,
        variables
      })
    },
    updateMe (variables) {
      return this.$apollo.mutate({
        mutation: updateMeMutation,
        variables
      })
    }
  }
}
</script>
<style scoped>
.v-tooltip__content {
  pointer-events: initial;
}
</style>
